"use client";

import { TranslationData } from "@/common/lib/types";
import Select from "@/components/ui/select/Select";
import { cn } from "@/lib/tailwind";
import { IPowerList } from "@/utils/product.utils";

interface IProps {
  translations: TranslationData;
  powerList: Record<string, IPowerList[]>;
  selectedColor: string;
  handleOptionClick: (val: string | number) => void;
  value?: string | number;
}

const PowerSelector = ({
  translations,
  powerList,
  selectedColor,
  value,
  handleOptionClick,
}: IProps) => {
  const powerMap = new Map<string, IPowerList>();

  powerList[selectedColor]
    ?.slice()
    .sort((a, b) => a.quantity - b.quantity)
    ?.forEach((item) => {
      if (!powerMap.has(item.power)) {
        powerMap.set(item.power, item);
      }
    });

  const items = Array.from(powerMap.values())?.map((v) => {
    return {
      value: v.power,
      label: <div className={cn(v.quantity > 0 ? "text-black" : "text-tertiary-4")}>{v.power}</div>,
    };
  });

  return (
    <Select
      options={items ?? []}
      onChange={(_, val) => handleOptionClick(val)}
      triggerLabel={translations?.pdp?.pdp_select_power_dropdown_placeholder}
      menuProps={{
        className: "border-1 border-[#C4C4C4] h-[10rem] overflow-y-auto rounded-[0.313rem]",
      }}
      triggerProps={{
        className:
          "border border-[#C4C4C4] rounded-[0.313rem] h-8 md:h-[30px] w-24 md:w-28 py-1 hover:bg-white ",
      }}
      value={value}
      parentProps={{
        className: "flex justify-end",
      }}
    />
  );
};

export default PowerSelector;
